module.exports = __webpack_public_path__ + "media/avc_alert_10s.d62960a0.mp3";